import React, { } from 'react';
import './EditProfile.scss';
import Header from '../component/Header.js';
import Footer from '../component/Footer.js';
import ProfileMenu from '../component/ProfileMenu';
const FeaturedItems = () => {



    return (
        <>
            <div className="mainCon">
                <Header />
                <div className='pt-4 pb-4 pt-md-5 pb-md-5'>
                    <div className='container'>
                        <div className='d-flex flex-wrap'>
                            <ProfileMenu />
                            <div className='profileDet'>
                                <div className='mainHd mb-2 mb-md-3'>Featured Items</div>
                                <div className='noteText'>You don't have any collected items to feature on your profile yet.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>

    )

}
export default FeaturedItems;